import React from "react";
import { BlockComponent } from "../UserInterface/BlockComponent";
import { DataPayment } from "../../data/DataPayment";

const PaymentBlocks = () => {
  return (
    <div className="blocks-wrapper">
      <div className="blocks-container">
        {DataPayment.map((data, key) => {
          return (
            <BlockComponent
              name={data.name}
              icon={data.image}
              slug={data.slug}
              imgWidth={data.width}
              key={key}
            ></BlockComponent>
          );
        })}
      </div>
      <style jsx>{`
        .blocks-wrapper {
          display: flex;
          justify-content: center;
        }
        .blocks-container {
          max-width: 940px;
          width: 100%;
          margin: 16px;
          grid-column-gap: 10px;
          grid-row-gap: 10px;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          justify-items: center;
        }
        @media only screen and (max-width: 700px) {
          .blocks-container {
            grid-template-columns: 1fr 1fr;
          }
        }
        @media only screen and (max-width: 600px) {
          .blocks-container {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentBlocks;
